<template>
  <div id="tabs-bar-container" class="tabs-bar-container">
    <el-tabs
      v-model="tabActive"
      type="card"
      class="tabs-content"
      @tab-click="handleTabClick"
      @tab-remove="handleTabRemove">
      <el-tab-pane
        v-for="item in visitedRoutes"
        :key="item.path"
        :label="item.meta.title"
        :name="item.path"
        :closable="!isAffix(item)"
      />
    </el-tabs>

    <div class="tabs-right">
      <el-dropdown trigger="click" @command="onUserCommand">
        <span class="user-entry">
          <el-avatar size="small" class="user-avatar">{{ avatarText }}</el-avatar>
          <span class="user-name">{{ displayName }}</span>
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人资料</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="handleCommand">
        <span style="cursor: pointer">
          更多操作
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown" class="tabs-more">
          <el-dropdown-item command="closeOtherstabs">关闭其他</el-dropdown-item>
          <el-dropdown-item command="closeLefttabs">关闭左侧</el-dropdown-item>
          <el-dropdown-item command="closeRighttabs">关闭右侧</el-dropdown-item>
          <el-dropdown-item command="closeAlltabs">关闭全部</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import path from 'path';
import { mapGetters } from 'vuex';
import { clearLoginState, goPasswordLogin, isInDingTalk, loginByDingTalk } from '@/utils/login';

export default {
  name: 'TabsBar',
  data() {
    return {
      affixtabs: [],
      tabActive: ''
    };
  },

  computed: {
    ...mapGetters({
      visitedRoutes: 'visitedRoutes',
      userId: 'userId',
      userInfo: 'userInfo',
    }),
    routes() {
      return this.$store.state.permission.routes
    },
    displayName() {
      return (this.userInfo && this.userInfo.name) || '用户'
    },
    avatarText() {
      const name = this.displayName
      return name ? name.substring(0, 1) : '用'
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.inittabs();
        this.addtabs();
        let tabActive = '';
        this.visitedRoutes.forEach((item, index) => {
          if (item.path === this.$route.path) {
            tabActive = item.path;
          }
        });
        this.tabActive = tabActive;

        // 添加到缓存视图中
        this.addToCache(route);
      },
      immediate: true
    },
    userId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$http.get('/api/user/' + val).then(res => {
            if (res.success) {
              this.$store.commit('demo/SET_USERINFO', res.data)
            }
          })
        }
      }
    }
  },
  methods: {
    onUserCommand(cmd) {
      if (cmd === 'profile') {
        this.$router.push('/profile')
      } else if (cmd === 'logout') {
        if (isInDingTalk()) {
          clearLoginState()
          loginByDingTalk(() => {
            this.$router.replace('/home')
          })
        } else {
          goPasswordLogin()
        }
      }
    },
    // 添加到缓存视图
    addToCache(route) {
      if (route.name) {
        this.$store.dispatch('tagsView/addView', route);
      }
    },
    // 从缓存中移除视图
    removeFromCache(route) {
      this.$store.dispatch('tagsView/delView', route);
    },
    async handleTabRemove(tabActive) {
      let view;
      this.visitedRoutes.forEach((item, index) => {
        if (tabActive == item.path) {
          view = item;
        }
      });
      
      // 从缓存中移除视图
      this.removeFromCache(view);
      
      const { visitedRoutes } = await this.$store.dispatch(
        'tabsBar/delRoute',
        view
      );
      if (this.isActive(view)) {
        this.toLastTag(visitedRoutes, view);
      }
    },
    handleTabClick(tab) {
      const route = this.visitedRoutes.filter((item, index) => {
        if (tab.index == index) return item;
      })[0];
      if (this.$route.path !== route.path) {
        this.$router.push({
          path: route.path,
          query: route.query,
          fullPath: route.fullPath
        });
      } else {
        return false;
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    filterAffixtabs(routes, basePath = '/') {
      let tabs = [];
      routes.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tabs.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          });
        }
        if (route.children) {
          const temptabs = this.filterAffixtabs(route.children, route.path);
          if (temptabs.length >= 1) {
            tabs = [...tabs, ...temptabs];
          }
        }
      });
      return tabs;
    },
    inittabs() {
      const affixtabs = (this.affixtabs = this.filterAffixtabs(this.routes));
      for (const tag of affixtabs) {
        if (tag.name) {
          this.$store.dispatch('tabsBar/addVisitedRoute', tag);
        }
      }
    },
    addtabs() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch('tabsBar/addVisitedRoute', this.$route);
      }
      return false;
    },
    handleCommand(command) {
      switch (command) {
        case 'refreshRoute':
          this.refreshRoute();
          break;
        case 'closeOtherstabs':
          this.closeOtherstabs();
          break;
        case 'closeLefttabs':
          this.closeLefttabs();
          break;
        case 'closeRighttabs':
          this.closeRighttabs();
          break;
        case 'closeAlltabs':
          this.closeAlltabs();
          break;
      }
    },
    async refreshRoute() {
      this.$baseEventBus.$emit('reloadrouter-view');
    },
    async closeSelectedTag(view) {
      // 从缓存中移除视图
      this.removeFromCache(view);
      
      const { visitedRoutes } = await this.$store.dispatch(
        'tabsBar/delRoute',
        view
      );
      if (this.isActive(view)) {
        this.toLastTag(visitedRoutes, view);
      }
    },
    async closeOtherstabs() {
      const view = await this.toThisTag();
      // 清除其他缓存视图
      await this.$store.dispatch('tagsView/delOthersViews', view);
      await this.$store.dispatch('tabsBar/delOthersRoutes', view);
    },
    async closeLefttabs() {
      const view = await this.toThisTag();
      // 这里需要手动处理左侧标签的缓存清理
      const leftRoutes = [];
      let found = false;
      this.visitedRoutes.forEach(route => {
        if (route.path === view.path) {
          found = true;
        }
        if (!found && !route.meta.affix) {
          leftRoutes.push(route);
        }
      });
      // 清除左侧路由的缓存
      leftRoutes.forEach(route => {
        this.removeFromCache(route);
      });
      await this.$store.dispatch('tabsBar/delLeftRoutes', view);
    },
    async closeRighttabs() {
      const view = await this.toThisTag();
      // 这里需要手动处理右侧标签的缓存清理
      const rightRoutes = [];
      let found = false;
      this.visitedRoutes.forEach(route => {
        if (found && !route.meta.affix) {
          rightRoutes.push(route);
        }
        if (route.path === view.path) {
          found = true;
        }
      });
      // 清除右侧路由的缓存
      rightRoutes.forEach(route => {
        this.removeFromCache(route);
      });
      await this.$store.dispatch('tabsBar/delRightRoutes', view);
    },
    async closeAlltabs() {
      const view = await this.toThisTag();
      // 清除所有缓存视图
      await this.$store.dispatch('tagsView/delAllViews');
      const { visitedRoutes } = await this.$store.dispatch(
        'tabsBar/delAllRoutes'
      );
      if (this.affixtabs.some((tag) => tag.path === view.path)) {
        return;
      }
      this.toLastTag(visitedRoutes, view);
    },
    toLastTag(visitedRoutes, view) {
      const latestView = visitedRoutes.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView);
      } else {
        this.$router.push('/');
      }
    },
    async toThisTag() {
      const view = this.visitedRoutes.filter((item, index) => {
        if (item.path === this.$route.fullPath) {
          return item;
        }
      })[0];
      if (this.$route.path !== view.path) this.$router.push(view);
      return view;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .tabs-bar-container {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    height: $base-tabs-bar-height;
    padding-right: $base-padding;
    padding-left: $base-padding;
    user-select: none;
    background: $base-color-white;
    border-top: 1px solid #f6f6f6;
    ::v-deep {
      .fold-unfold {
        margin-right: $base-padding;
      }
    }

    .tabs-content {
      width: calc(100% - 220px);
      height: $base-tag-item-height;

      ::v-deep {
        .el-tabs__nav-next,
        .el-tabs__nav-prev {
          height: $base-tag-item-height;
          line-height: $base-tag-item-height;
        }

        .el-tabs__header {
          border-bottom: 0;

          .el-tabs__nav {
            border: 0;
          }

          .el-tabs__item {
            box-sizing: border-box;
            height: $base-tag-item-height;
            margin-right: 5px;
            line-height: $base-tag-item-height;
            // border: 1px solid $base-border-color;
            transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
            border-left: none;
            padding: 0px 15px;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              right: 0px;
              top: 8px;
              height: 20px;
              width: 1px;
              background-color: #dcdcdc;
            }
            &.is-active {
              color: $base-color-blue;
              background-color: #f0f2f5;
              border-radius: 8px 8px 0px 0px;
              border-right: none;
              &::after {
                display: none;
              }
            } 
            &:hover {
              color: $base-color-blue;
            }
          }
        }
      }
    }

    .more {
      display: flex;
      align-content: center;
      align-items: center;
      cursor: pointer;
    }
    .tabs-right {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
    }
    .user-entry {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      color: #333;
    }
    .user-avatar {
      background: #098cfc;
      margin-right: 6px;
    }
    .user-name {
      margin-right: 4px;
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
